import { render, staticRenderFns } from "./OrderBy.vue?vue&type=template&id=1fa67c5d&"
import script from "./OrderBy.vue?vue&type=script&lang=js&"
export * from "./OrderBy.vue?vue&type=script&lang=js&"
import style0 from "./OrderBy.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports